export const hasMore = (state) => !!state.previousTransferPaymentId
export const noPotRefunds = (state) => state.potRefunds.length === 0
